import { useEffect, useState, useRef } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";

import Message from "@/components/Message/index";
import { newPath, EmailHost, SubhubHost, BuyDmail, NFTsLink, LiepaperLink, BlogLink, GitBookLink, DmailDocs, PointsDailies } from '@/utils/index'
import SvgsCommons from "@/components/svgs/commons";
import { useScroll } from './utils'
import { Header, Nav } from './css'

export const NavList = [
  {
    name: 'Dmail DApp',
    path: `${newPath}/dapp`,
  },
  // {
  //   name: 'Subscription & Notification',
  //   href: `${SubhubHost}`,
  // },
  {
    name: 'Resources',
    children: [
      {
        name: 'Docs',
        href: GitBookLink,
      },
      {
        name: 'Blog',
        href: BlogLink,
      },
      // {
      //   name: '$DMAIL',
      //   href: DmailDocs,
      // },
      // {
      //   name: 'Ambassador',
      //   path: `${newPath}/ambassador`,
      // },
    ],
  },
  {
    name: 'Snap',
    path: `${newPath}/snap`,
  },
  {
    name: 'Domain',
    // path: `${newPath}/domain`,
    href: `${EmailHost}/domain`,
    split: true,
  },
  // {
  //   name: 'Airdrop',
  //   icon: 'hot',
  //   empty: true,
  // },
  // {
  //   name: 'Earning',
  //   icon: 'gift',
  //   empty: true,
  // },
]

NavList.push(
  {
    name: 'Earn Rewards',
    icon: 'hot',
    // href: `${EmailHost}/airdrop`,
    children: [
      // {
      //   name: 'Airdrop',
      //   // icon: 'hot',
      //   href: `${EmailHost}/airdrop`,
      // },
      {
        name: 'Dmail Points',
        href: PointsDailies,
      },
    ],
  },
  {
    name: 'Staking',
    icon: 'gift',
    path: `${newPath}/stake`,
    // empty: true,
  }
)

const Chunk = ({ store, location: { pathname }, currentName, className }) => {
  const { isMobile } = store.common;
  const history = useHistory();
  const toHome = () => history.push(`${newPath}/`)
  
  const [mobileNavShow, setMobileNavShow] = useState(false)
  const onSettingClick = () => {
    setMobileNavShow(!mobileNavShow)
  }
  const bodyClick = (ev) => {
    if (!ev.target.closest('.__js_setting')) {
      setMobileNavShow(false)
    }
  }
  useEffect(() => {
    const nav = document.querySelector('.__js_setting')
    if (isMobile) {
      // avoid window size change ui bug
      nav && nav.classList.remove('hide')
      document.body.addEventListener('click', bodyClick)

      return () => {
        document.body.removeEventListener('click', bodyClick)
      }
    } else {
      setMobileNavShow(false)
    }
  }, [isMobile])

  useEffect(() => {
    const nav = document.querySelector('.__js_setting')
    if (nav) {
      // avoid window size change ui bug
      nav.classList[mobileNavShow ? 'add' : 'remove']('show')
    }
  }, [mobileNavShow])

  const [current, setCurrent] = useState(currentName || '')
  const [currentSon, setCurrentSon] = useState('')
  const toPath = (parentName, options) => () => {
    const { name, path, href } = options
    if (href) {
      window.open(href)
    } else if (path) {
      setCurrent(parentName)
      name && setCurrentSon(name)
      history.push(path);
    }
  }

  const headerRef = useRef(null)
  const noScroll = pathname.includes(`${newPath}/news_detail/`)
  useScroll(headerRef, noScroll)

  // const isPresaleSon = [`${newPath}/referrals`, `${newPath}/orders`, ].includes(pathname)

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    for (const { path, name, children } of NavList) {
      if (path === pathname) {
        setCurrent(name)
        break
      }
      if (Array.isArray(children)) {
        for (const item of children) {
          if (pathname.indexOf(item.path) === 0) {
            setCurrentSon(item.name)
            setCurrent(name)
            break
          }
        }
      }
    }
  }, [pathname])

  return (
    <Header className={[isMobile ? 'sub-mobile' : '', className || ''].join(' ')} ref={headerRef}>
      <a onClick={toHome}>
        <SvgsCommons type={currentName !== "stake" || (isMobile && mobileNavShow) ? "logo" : "logoGray"} width={isMobile ? "81" : "125"} height={isMobile ? "23" : "34"} />
      </a>
      <Nav className={[isMobile ? `sub-mobile hide __js_setting` : '', className ? `${className}-nav` : ''].join(' ')}>
        {isMobile ? (
          <div className={current === '' ? 'on' : ''} onClick={toHome}>
            <span>Home</span>
          </div>
        ): null}
        {NavList.map((item) => {
          const { split, children, path, href, icon, empty } = item
          const more = Array.isArray(children) && !!children.length
          let className = current === item.name ? 'on' : ''
          more && (className += ' more')
          split && (className += ' split')
          empty && (className += ' empty')
          icon && (className += ' has-icon')
          return <div className={className} key={item.name} style={{ paddingBottom: isMobile && more ? children.length * 36 + 20 : '' }} onClick={toPath(item.name, { path, href })}>
            {icon ? <i className={icon}></i> : null}
            <span>{item.name}</span>
            {more ? (
              <ul className='children'>
                {children.map((_item) => (
                  <li onClick={toPath(item.name, _item)} className={currentSon === _item.name ? 'on' : ''} key={_item.name}>
                    {_item.icon ? <i className={_item.icon}></i> : null}
                    {_item.name}
                  </li>
                ))}
              </ul>
            ) : null}
            {more ? <SvgsCommons type="down" /> : null}
          </div>
        })}
      </Nav>
      {/* {isMobile ? null : (
        <a className="outlined-red buy-dmail" href={BuyDmail} target='_blank'><SvgsCommons type="shoppingCar" width={isMobile ? 17 : 20} height={isMobile ? 14 : 15} /><span>Get DMAIL</span></a>
      )} */}
      <span></span>
      {isMobile ? (
        <div className={`setting ${mobileNavShow ? 'close' : ''} __js_setting`} onClick={onSettingClick}>
          <div>
            <span></span>
          </div>
        </div>
      ) : null}
    </Header>
  )
}

export default withRouter(inject("store")(observer(Chunk)))